/** The codes an API key meets, as the contract's Problem schema lists them. */
export const codes: readonly { status: number; code: string; meaning: string }[] = [
  {
    status: 400,
    code: 'invalid_request',
    meaning: 'The body or a parameter was refused; detail says which.',
  },
  {
    status: 400,
    code: 'idempotency_key_required',
    meaning: 'This call needs an Idempotency-Key header.',
  },
  {
    status: 400,
    code: 'unreadable',
    meaning:
      'An uploaded file could not be decoded; send it again as a valid PDF, TIFF, PNG or JPEG.',
  },
  {
    status: 401,
    code: 'unauthenticated',
    meaning: 'No key, or one that is unknown, revoked or past its end date.',
  },
  {
    status: 403,
    code: 'paid_plan_required',
    meaning: 'The company is on Free; an admin chooses a plan in Paige and the key works again.',
  },
  { status: 403, code: 'forbidden', meaning: 'The key’s role does not allow this call.' },
  {
    status: 404,
    code: 'not_found',
    meaning: 'Nothing of your company’s at that address, or a package not ready yet.',
  },
  {
    status: 404,
    code: 'unknown_job',
    meaning:
      'An upload named a job that is not one of the company’s; nothing was kept. (An upload that names no job at all is a 400.)',
  },
  { status: 409, code: 'name_taken', meaning: 'Another job of the company has that name.' },
  {
    status: 409,
    code: 'transition_not_allowed',
    meaning: 'The job cannot move to that state from where it is.',
  },
  {
    status: 409,
    code: 'setup_not_finished',
    meaning:
      'The job was paused or archived before its setup was finished; it goes back to setup, not on.',
  },
  {
    status: 409,
    code: 'idempotency_in_progress',
    meaning: 'The first request with this key is still running; retry after Retry-After.',
  },
  {
    status: 413,
    code: 'too_large',
    meaning: 'A file over 29.9 MB, or a request over 30 MB; send fewer or smaller files.',
  },
  {
    status: 415,
    code: 'unsupported_format',
    meaning: 'A file that is not PDF, TIFF, PNG or JPEG.',
  },
  {
    status: 422,
    code: 'idempotency_conflict',
    meaning: 'This Idempotency-Key was used for a different request; use a new one.',
  },
  {
    status: 429,
    code: 'rate_limited',
    meaning: 'Over 1,200 requests a minute; wait the seconds Retry-After says.',
  },
  {
    status: 500,
    code: 'internal_error',
    meaning: 'Ours. Retry with the same Idempotency-Key; quote requestId if it stays.',
  },
  {
    status: 503,
    code: 'uploads_busy',
    meaning:
      'Too many uploads arriving at once; send it again after Retry-After, with the same Idempotency-Key.',
  },
  {
    status: 503,
    code: 'unavailable',
    meaning: 'Briefly unavailable. Retry with the same Idempotency-Key after a pause.',
  },
];

/** The answer to a change sent without its key, as Paige gives it. */
export const problemExample = `HTTP/1.1 400 Bad Request
Content-Type: application/problem+json
X-Request-Id: 4712daf86c74eb57bafcd74e7faf0e69

{
  "type": "https://tools.ietf.org/html/rfc9110#section-15.5.1",
  "title": "Bad Request",
  "status": 400,
  "detail": "Idempotency-Key header is required (1 to 128 characters): a value of your own, new for each change, the same on a retry of it",
  "code": "idempotency_key_required",
  "requestId": "4712daf86c74eb57bafcd74e7faf0e69"
}`;
